import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          <p className="footer-company">Fitness First Sports</p>
          <p className="footer-address">816 Main St, Kerrville, TX 78028</p>
          <p className="footer-phone">(830) 896-0114</p>
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Fitness First Sports. All rights reserved.
        </div>
        <div className="footer-built-by">
          <a href="https://www.demetrion.dev" target="_blank" rel="noopener noreferrer">
            Built With Demetrion.Dev
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
